import{__assign as e}from'./../ext/tslib/tslib.es6.js';import r from"react";import{StackView as t}from"../StackView/StackView.js";var i=function(i){return r.createElement(t,e({role:"cell",axis:"horizontal",shrink:0,paddingVertical:.5},i))};export{i as default};
//# sourceMappingURL=BodyCell.js.map
